import type { BariPreSecretarialAssistantMedScreeningReportDataV1 } from '@common/validation/customControls/bariPre/bariPreSecretarialAssistantMedScreeningReport/v1/bariPreSecretarialAssistantMedScreeningReportDataV1';
import { initialData } from '../bariPreSecretarialAssistantMedScreeningReportData';

export const initialDataV1: BariPreSecretarialAssistantMedScreeningReportDataV1 = {
    ...initialData,
    roken: null,
    roken_aantal_pack_years: null,
    roken_gestopt_sinds: null,
    roken_toelichting: null,
};
